import _toConsumableArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
// import Paper from '@material-ui/core/Paper';
import CardContent from '@mui/material/CardContent';
import FieldCheckbox from '../../../../molecules/opportunity-wizard/FieldCheckbox';
import Typography from '../../../../atoms/Typography';
import SectionSkeleton from './skeleton';
import { Paper } from './style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var GeneralFields = function GeneralFields(_ref) {
  var key = _ref.key,
    section = _ref.section,
    formFields = _ref.formFields,
    setFormFields = _ref.setFormFields;
  return /*#__PURE__*/_jsx(Paper, {
    variant: "outlined",
    children: /*#__PURE__*/_jsxs(CardContent, {
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        children: section.name
      }), section.fields.length > 0 && section.fields.map(function (field) {
        var checked = field.is_required || formFields.fields.includes(field.id);
        if (field.is_required && !formFields.fields.includes(field.id)) {
          var newFormFields = _objectSpread({}, formFields);
          newFormFields.fields = [].concat(_toConsumableArray(formFields.fields), [field.id]);
          setFormFields(newFormFields);
        }
        var fieldView = null;
        fieldView = /*#__PURE__*/_jsx(FieldCheckbox, {
          checked: checked,
          onClick: function onClick() {
            if (!field.is_required) {
              if (checked) {
                var _newFormFields = _objectSpread({}, formFields);
                _newFormFields.fields.splice(formFields.fields.indexOf(field.id), 1);
                setFormFields(_newFormFields);
              } else {
                var _newFormFields2 = _objectSpread({}, formFields);
                _newFormFields2.fields = [].concat(_toConsumableArray(formFields.fields), [field.id]);
                setFormFields(_newFormFields2);
              }
            }
          },
          children: field.name
        });
        return fieldView;
      })]
    })
  }, key);
};
GeneralFields.defaultProps = {
  key: undefined
};
GeneralFields.Skeleton = SectionSkeleton;
export default GeneralFields;